import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { SOTService } from '../../services';
import { Subscription } from 'rxjs';

@Component({
  selector: "sot-startcardscan",
  templateUrl: "./startcardscan.component.html",
  styleUrls: ["./startcardscan.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StartCardscanComponent implements OnInit, OnDestroy {
  private scanCardSubscription: Subscription;
  public isModeOne: boolean = false;
  public isModeTwo: boolean = false;

  public get has_logo_image(): boolean {
    return this._sotService.GetSettings().has_logo_image;
  }

  public get logo_image_path(): string {
    return this._sotService.GetSettings().logo_image_path;
  }

  public constructor(private _changeDetectorRef: ChangeDetectorRef
    , private _sotService: SOTService) {
  }

  public ngOnInit(): void {
    const me = this;
    me.isModeOne = me._sotService.useModeOne();
    me.isModeTwo = me._sotService.useModeTwo();
    me.scanCardSubscription = me._sotService.evScanCardDone.subscribe((success) => {
      if (success) {
        me._sotService.GoToMenu(null);
      } else {
        me._sotService.OpenCardCouldNotBeReadDialog(() => {
          me._sotService.SOTConnectionSendScanCard();
        });
      }
    });
    me._sotService.SOTConnectionSendScanCard();
  }

  public ngOnDestroy(): void {
    const me = this;
    if (me.scanCardSubscription) {
      me.scanCardSubscription.unsubscribe();
    }
  }

  public back(): void {
    const me = this;
    me._sotService.SOTConnectionSendCancelScanning();
    me._sotService.GoToOrdertype();
  }
}
